/** @format */

import React from "react";

const Background = ({ classes }) => {
	return (
		<div className="background" id={classes}>
			<div className="one"></div>
			<div className="two"></div>
			<div className="three"></div>
			<div className="four"></div>
			<div className="five"></div>
			<div className="six"></div>
			<div className="seven"></div>
			<div className="eight"></div>
			<div className="nine"></div>
		</div>
	);
};

export default Background;
